module.exports = __webpack_public_path__ + "img/mdiFileSendOutline.a8d56344.svg";